export default __webpack_public_path__ + "static/profile_logo_white-2e8ea631a10394316cc9188f6037d3a6.svg";